/*
 * Module for the topic label list.  To be shared by the topic label modal and the topic decision area
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/topicLabelList/topicLabelListView",
  "modules/shared/topicLabelList/topicLabelListModel",
  "modules/shared/sortableList/sortableListModule",
], function (Marionette, Messenger, TopicLabelListView, TopicLabelListModel, SortableListModule) {
  var TopicLabelListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicLabelList";
      this.hideEnglishLabel = options.hideEnglishLabel; //boolean used to hide the decision label for English
      this.hideHeader = options.hideHeader;
      this.namespace = options.namespace; //namespace used by the sortable list
      this.includeTouchPoint = options.includeTouchPoint;
    },
    show: function (topicLabels, alreadyPrepared) {
      if (!alreadyPrepared) {
        //prepare topicLabels collection for being shown (make sure they are ready first)
        topicLabels.onSynced(() => this.prepareTopicLabels(topicLabels));
      }

      this.layout = new TopicLabelListView.topicLabelListLayout();
      var headers;
      if (!alreadyPrepared) {
        headers = Messenger.reqres.request("topic:label:headers"); //get the headers for the sortableList
      } else {
        headers = Messenger.reqres.request("topic:label:headers:noedit"); //get the headers for the sortableList
      }
      this.labelList = this.addSubModule(
        new SortableListModule({
          region: this.layout.labelList,
          headers: headers,
          hideControls: true,
          hideHeader: this.hideHeader,
          namespace: this.namespace,
        }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(topicLabels);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    prepareTopicLabels: function (topicLabels) {
      //get language list
      const languageList = Messenger.reqres.request("kb:languages");
      //continue once the language list is ready
      languageList.onSynced(() => this._prepareTopicLabels(topicLabels, languageList));
    },
    _prepareTopicLabels: function (topicLabels, languageList) {
      //make sure is a topic label for each language in the KB
      languageList.each(function (language) {
        //find matching topic label
        var topicLabel = topicLabels.findWhere({ languageId: language.get("id") });
        if (!topicLabel) {
          //create new topic label
          topicLabel = topicLabels.addLabel(language.get("id"));
        }
        topicLabel.languageName = language.get("name");
        if (topicLabel.get("languageId") === 1 && this.hideEnglishLabel) {
          //"filter" out topic label for english
          topicLabel.hideModel = true;
        }
      }, this);
      //also check if there are any topic labels that are in a language not in the KB. If so, remove them from the collection
      var labelsToRemove = [];
      topicLabels.each(function (label) {
        var lang = languageList.findWhere({ id: label.get("languageId") });
        if (!lang) {
          //language of topic label is not supported by the KB, so remove the topic label (on client side, not server side)
          labelsToRemove.push(label);
        }
      });
      topicLabels.remove(labelsToRemove);
      //sort in order to rerender the sortableList
      topicLabels.sort();
    },
    _showSubViews: function (topicLabels) {
      this.labelList.show(topicLabels);
    },
  });

  return TopicLabelListController;
});
